import React, { useEffect, useState } from 'react';
import { api } from '../../App';
import toast from 'react-hot-toast';

export default function PublicLinkBase() {
  const [data, setData] = useState(null);
  const [url, setUrl] = useState('');
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const r = await api.get('/api/system/public-url');
      setData(r.data);
      setUrl(r.data.override || '');
    } catch { /* non-super admins never render this */ }
  };
  useEffect(() => { load(); }, []);

  const save = async (value) => {
    setSaving(true);
    try {
      const r = await api.put('/api/system/public-url', { url: value });
      setData(d => ({ ...d, ...r.data }));
      setUrl(r.data.override || '');
      toast.success(value ? 'Shared links now use this address' : 'Reverted to the deployed address');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not save');
    }
    setSaving(false);
  };

  if (!data) return null;
  return (
    <div className="card p-5 max-w-4xl" data-testid="public-link-base">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <p className="text-[10px] font-bold uppercase tracking-widest text-text-muted">Shared link address</p>
          <h4 className="font-heading font-black text-lg text-text-primary mt-0.5">Where your proposal & invite links point</h4>
          <p className="text-[11px] text-text-secondary mt-1 max-w-2xl">
            Every proposal link, homeowner portal, careers page, invite and email button is built from this address.
            If your custom domain ever goes down, point it at your backup address here and every new link works again — no redeploy.
          </p>
        </div>
        <span className="text-[10px] font-bold px-2.5 py-1 rounded-full border bg-emerald-50 text-emerald-700 border-emerald-200 whitespace-nowrap" data-testid="public-link-effective-badge">
          {data.override ? 'Custom override' : 'Deployed default'}
        </span>
      </div>

      <div className="mt-4 p-3 rounded-xl border border-border bg-surface-alt/50">
        <p className="text-[10px] font-bold uppercase tracking-widest text-text-muted">Links are being built as</p>
        <p className="text-sm font-mono text-text-primary mt-1 break-all" data-testid="public-link-effective">{data.effective || '— not set —'}</p>
        {data.is_preview && <p className="text-[11px] text-amber-600 mt-1.5" data-testid="public-link-preview-warning">This is a preview address — homeowners should get your deployed domain instead.</p>}
      </div>

      <div className="mt-4 flex gap-2 flex-wrap items-center">
        <input
          value={url}
          onChange={e => setUrl(e.target.value)}
          placeholder={data.env || 'https://your-domain.com'}
          className="flex-1 min-w-[260px] px-3 py-2 rounded-xl border border-border bg-surface text-sm font-mono"
          data-testid="public-link-input"
        />
        <button onClick={() => save(url)} disabled={saving} className="px-4 py-2 rounded-full text-sm font-bold disabled:opacity-60" style={{ background: '#0C2417', color: '#fff' }} data-testid="public-link-save-btn">
          {saving ? 'Saving…' : 'Use this address'}
        </button>
        {data.override && (
          <button onClick={() => save('')} disabled={saving} className="px-4 py-2 rounded-full text-sm font-semibold border border-border text-text-secondary disabled:opacity-60" data-testid="public-link-reset-btn">
            Reset to deployed
          </button>
        )}
      </div>
      <p className="text-[10px] text-text-muted mt-2">Must start with https:// · Deployed address: <span className="font-mono">{data.env || 'not set'}</span></p>
    </div>
  );
}
